import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-payments-reports-per-gateway-zoom-card',
  templateUrl: './payments-reports-per-gateway-zoom-card.component.html',
  styleUrls: ['./payments-reports-per-gateway-zoom-card.component.scss']
})
export class PaymentsReportsPerGatewayZoomCardComponent implements OnInit, AfterViewInit {

  @ViewChild('perPlatform', { static: false }) perPlatformRef: ElementRef;
  ctx;
  myChart;
  data2;
  title;
  colors;
  selectedMode;

  constructor(@Inject(MAT_DIALOG_DATA) public data,
              private dialogRef: MatDialogRef<MatDialog>) { }

  ngOnInit() {
    this.data2 = this.data.data;
    this.title = this.data.title;
    this.colors = this.data.colors;
  }

  ngAfterViewInit() {
    this.ctx = this.perPlatformRef.nativeElement.getContext('2d');
    this.render(this.data2);
  }

  public close() {
    this.dialogRef.close();
  }

  public render(data) {
    if (this.myChart) {
      this.myChart.destroy();
    }
    this.ctx = this.perPlatformRef.nativeElement.getContext('2d');
    this.myChart = new Chart(this.ctx, {
      type: 'pie',
      responsive: true,
      data: {
        labels: data.map(d => d.platform),
        datasets: [
          {
            label: 'Dataset 1',
            data: data.map(d => d.nbTransactions),
            backgroundColor: data.map((d, i) => this.colors[i] ),
          }
        ]
      },
      options: {
        legend: {
          position: 'right'
        }
      }
    });
  }

}
